import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Search from '@material-ui/icons/Search'
import { API, DATE, CURRENCY } from '@const'
import * as utils from '@utils'
import { Grid, Divider, Button, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core'
import { Decimal } from 'decimal.js'
import { DateSelect, CompleteDecimal } from '@select'
import Table from '@tables/table'
import FinanceReconciliationDialog from '@dialogs/finance-reconciliation-dialog'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import { PlayerBetReportTable } from '@tables'
import ComponentDialog from '@dialogs/component-dialog'
import moment from 'moment'
import { addToast } from '../../utils/toast'

const COMPONENT_GROUP = 'finance_reconciliation';

class FinanceReconciliationPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'FinanceReconciliationPage')
        }
    }

    state = {
        proprietor: 'all',
        proprietorList: [],
        timeZone: '-4'
    }

    actions = []
    options = { export: false }
    columns = [
        { field: 'proprietor_name' },
        { field: 'pf_sub_pf_id', type: 'platform' },
        { field: 'currency'},
        { 
            field: 'bet_player_amount',
            type: 'numberByThous',
            render: (rowData, display) => {
                return display === '--' ? display : (
                    <Button
                        className={this.props.classes.linkButton}
                        onClick={() => {
                            const compDialogArgs = {
                                apiUrl: API.BET_RECORD_SUM_LIST_BY_REPORT_PF_ACCOUNT,
                                dateUnit: DATE.DATEPART_MONTH,
                                startDate: this.dateSelect.state.startDate,
                                endDate: this.dateSelect.state.endDate,
                                pfId: '',
                                proprietor_id: !rowData.parent ? rowData.proprietor_id: '',
                                pfSubPfId: rowData.parent ? rowData.pf_sub_pf_id : '',
                                exportType: 'report_pf_account',
                                timeZone: this.state.timeZone
                            }
                            this.compDialog.OpenDialog(
                                this.t('PlayerBetReportTable'),
                                <PlayerBetReportTable
                                    compDialogArgs={{...compDialogArgs}}>
                                </PlayerBetReportTable>
                            )
                        }}>
                        {display}
                    </Button>
                )
            },
        },
        { field: 'total_bet', type: 'currency' },
        {
            field: 'proprietor_profit',
            type: 'currency',
            render: (row, display) => {
                const fontColor = row['proprietor_profit'] < 0 ? 'red' : ''
                return <div style={{ color: fontColor }}>{display}</div>
            },
        },
        { field: 'proprietor_tax', type: 'currency' },
        {
            field: 'edit',
            type: 'action',
            hideTitle: true,
            render: (rowData) =>
                rowData['parent'] === undefined && (
                    <Button
                        onClick={() => {
                            this.dialog.OpenDialog('edit', this.state.proprietorList, rowData['proprietor_id'])
                        }}
                        variant="contained"
                        color="primary">
                        {this.t('edit')}
                    </Button>
                ),
        },
        {
            field: 'delete',
            type: 'action',
            hideTitle: true,
            render: (rowData) =>
                rowData['parent'] === undefined && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.confirmDialog.OpenDialog({
                                type: 'info',
                                msg: this.t('confirmDeleteMsg'),
                                confirm: (_params) => {
                                    utils.apiRequest(
                                        'delete',
                                        API.PROPRIETOR,
                                        {
                                            id: rowData['proprietor_id'],
                                        },
                                        (_data) => {
                                            this.queryProprietorListData()
                                            this.confirmDialog.closeDialog()
                                        }
                                    )
                                },
                            })
                        }}>
                        {this.t('delete')}
                    </Button>
                ),
        },
    ]

    componentDidMount() {
        this.queryProprietorListData()
        this.actions.push({
            text: 'add',
            icon: 'add',
            isFreeAction: true,
            onClick: () => {
                this.dialog.OpenDialog('add', this.state.proprietorList)
            },
        })
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.options.export = true
        }
    }

    queryProprietorListData() {
        this.table.SetLoading(true)

        utils.apiRequest(
            'get',
            API.PROPRIETOR_LIST,
            {},
            (data) => {
                const tableData = []

                let count = 0
                data.forEach((elem) => {
                    if (!Array.isArray(elem['pf_sub_pf_id_list']) || elem['pf_sub_pf_id_list'].length <= 0) return

                    const parentID = count++
                    const countPfSubPfId = 'count_' + elem['pf_sub_pf_id_list'].length

                    tableData.push({
                        id: parentID,
                        proprietor_id: parseInt(elem['id']),
                        proprietor_name: elem['name'],
                        pf_sub_pf_id: countPfSubPfId,
                        currency: `${utils.getPfSubPfCurrency(elem['pf_sub_pf_id_list'][0])}`,
                        proprietor_profit: CURRENCY.EMPTY_MONEY,
                        proprietor_tax: CURRENCY.EMPTY_MONEY,
                        total_bet: CURRENCY.EMPTY_MONEY,
                        bet_player_amount: CURRENCY.EMPTY_MONEY
                    })

                    elem['pf_sub_pf_id_list']
                        .sort((a, b) => utils.SortPlatform(a, b))
                        .forEach((pfSubPfID) => {
                            tableData.push({
                                id: count++,
                                proprietor_name: elem['name'],
                                pf_sub_pf_id: pfSubPfID,
                                currency: `${utils.getPfSubPfCurrency(pfSubPfID)}`,
                                parent: parentID,
                                proprietor_profit: CURRENCY.EMPTY_MONEY,
                                proprietor_tax: CURRENCY.EMPTY_MONEY,
                                total_bet: CURRENCY.EMPTY_MONEY,
                                bet_player_amount: CURRENCY.EMPTY_MONEY
                            })
                        })
                })

                this.table.SetData(tableData)
                this.setState({
                    proprietorList: data,
                })
            },
            (_err) => {
                this.table.SetData([])
            },
            true
        )
    }

    queryData = () => {
        const startDate = this.dateSelect.state.startDate
        const endDate = this.dateSelect.state.endDate
        if (moment(endDate).isBefore(startDate, 'month')) {
            addToast(utils.t('ValidationMsg.startTimeCannotAfterEndTime'), 'error')
            return
        }
        this.table.SetLoading(true)
        const queryParams = {
            start_date: utils.datetimeToUnix_startOf(startDate, DATE.DATEPART_MONTH),
            end_date: utils.datetimeToUnix_endOf(endDate, DATE.DATEPART_MONTH),
            timezone: this.state.timeZone
        }

        utils.apiRequest(
            'get',
            API.PROPRIETOR_RECONCILIATION_DATA_LIST,
            queryParams,
            (data) => {
                const tableData = this.table.GetData()

                tableData.forEach((elem) => {
                    elem['proprietor_profit'] = 0
                    elem['proprietor_tax'] = 0
                    elem['total_bet'] = 0
                    elem['bet_player_amount'] = 0
                })

                data.forEach((elem) => {
                    const pfSubPfRowData = tableData.find((row) => row['pf_sub_pf_id'] === elem['pf_sub_pf_id'])
                    pfSubPfRowData['proprietor_profit'] = new Decimal(pfSubPfRowData['proprietor_profit']).add(elem['operator_profit'])
                    pfSubPfRowData['proprietor_tax'] = new Decimal(pfSubPfRowData['proprietor_tax']).add(elem['total_tax'])
                    pfSubPfRowData['total_bet'] = new Decimal(pfSubPfRowData['total_bet']).add(elem['total_bet'])
                    pfSubPfRowData['bet_player_amount'] = new Decimal(pfSubPfRowData['bet_player_amount']).add(elem['bet_player_amount'])

                    const proprietorRowData = tableData.find((row) => row['id'] === pfSubPfRowData.parent)
                    proprietorRowData['proprietor_profit'] = new Decimal(proprietorRowData['proprietor_profit']).add(elem['operator_profit'])
                    proprietorRowData['proprietor_tax'] = new Decimal(proprietorRowData['proprietor_tax']).add(elem['total_tax'])
                    proprietorRowData['total_bet'] = new Decimal(proprietorRowData['total_bet']).add(elem['total_bet'])
                    proprietorRowData['bet_player_amount'] = new Decimal(proprietorRowData['bet_player_amount']).add(elem['bet_player_amount'])
                })
                this.table.SetData(tableData)
            },
            (_err) => {
                this.queryProprietorListData()
            }
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <DateSelect datepart={DATE.DATEPART_MONTH} onRef={(ref) => (this.dateSelect = ref)}></DateSelect>
                <FormControl
                    className={this.props.classes.timeformControl}>
                    <InputLabel>{this.t('timeZone')}</InputLabel>
                    <Select
                        value={this.state.timeZone}
                        onChange={(event) =>
                            this.setState({
                                timeZone: event.target.value
                            })
                        }>
                        {
                            Array.from({ length: 27 }).map((_item, index) => {
                                return (
                                    <MenuItem value={`${index-12}`} key={index-12}>GMT {index-12 >= 0 ? `+${index-12}` : index-12 }</MenuItem>
                                )
                            })
                        }
                    </Select>
                </FormControl>
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        onClick={() => this.queryData()}
                        disabled={this.state.proprietorList.length <= 0}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                    {this.state.proprietorList.length <= 0 && (
                        <div style={{ marginLeft: '12px', color: 'red' }}>{this.t('addProprietorFirstMsg')}</div>
                    )}
                </Grid>
                <Grid item className={this.props.classes.completeDecimal}>
                    <CompleteDecimal />
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Table
                        ownerName="FinanceReconciliationPage"
                        columns={this.columns}
                        options={this.options}
                        actions={this.actions}
                        onRef={(ref) => (this.table = ref)}
                        parentChildData={(row, rows) => rows.find((a) => a.id === row.parent)}
                    />
                </Grid>
                <FinanceReconciliationDialog onRef={(ref) => (this.dialog = ref)} confirmCallback={() => this.queryProprietorListData()} />
                <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                <ComponentDialog onRef={(ref) => (this.compDialog = ref)}></ComponentDialog>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        textField: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        hide: {
            display: 'none',
        },
        completeDecimal: {
            marginTop: 5,
        },
        timeformControl: {
            margin: theme.spacing(1),
            width: '120px',
        },
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            color: '#1890ff',
            textDecoration: 'none',
            cursor: 'pointer',
            userSelect: 'text',
            outline: 'none !important',
            '& span': {
                justifyContent: 'flex-end',
            }
        },
    }
}

FinanceReconciliationPage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
}

export default hoc(styles)(FinanceReconciliationPage)
